import dayjs from "dayjs"
import { CUSTOM_TIME_FORMAT } from "constants"
import { convertCamelCaseToReadable } from "../../../../utils"
import { dateTimeFunction } from "../../../../utils/date"

export const whatsappChatInsightsTransformer = response => {
  const transformMediaDistribution = data =>
    Object.entries(data)?.map(([key, value]) => ({
      label: convertCamelCaseToReadable(key),
      count: value,
    }))
  const transformEngagementScores = data => {
    return data?.map(item => ({
      ...item,
      date: dateTimeFunction({ date: item?.date }),
    }))
  }
  let summary = {
    ...response?.data?.summary,
    projectsDiscussed: response?.data?.insights?.projectsDiscussed,
  }
  let insights = {
    ...response?.data?.insights,
    ...response?.data?.engagement,
    ...response?.data?.trends,
    engagementScores: transformEngagementScores(response?.data?.trends?.engagementScores),
    mediaDistribution: transformMediaDistribution(response?.data?.engagement?.mediaDistribution),
  }

  const messageBestHour = () => {
    const bestHour = response?.data?.trends?.bestTimeToMessage.reduce((max, item) =>
      item?.score > max?.score ? item : max
    )?.hour
    if (bestHour != null) {
      const start = dayjs().hour(bestHour).minute(0).second(0)
      const end = start?.add(1, "hour")
      return [start, end]
    }
    return []
  }
  return {
    ...response?.data,
    summary,
    insights,
    bestMessageHour: `${messageBestHour()?.[0]?.format(CUSTOM_TIME_FORMAT)} - ${messageBestHour()?.[1]?.format(
      CUSTOM_TIME_FORMAT
    )}`,
    isCurrentHourBest: dayjs().isAfter(messageBestHour()?.[0]) && dayjs().isBefore(messageBestHour()?.[1]),
    bestTimeToMessage: !!response?.data?.trends?.bestTimeToMessage?.length > 0,
  }
}
